<template>
  <div id="app" @click="appClick">
    <!-- Navbar Start -->
    <header class="header-strip">
      <div class="navbar-left">
        <Breadcrumb v-if="showBreadcrumb" :moduleArray="userObject.userModules"/>
      </div>
      <div class="navbar-right">
        <Notifications :notificationArray="userObject.userNotifications"/>
        <Settings :userObject="userObject"/>
      </div>
    </header>
    <!-- Navbar End -->

    <router-view/>

    <!-- Menu Modal Start -->
    <MenuModal/>
    <!-- Menu Modal End -->
  </div>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/nav/Breadcrumb.vue'
import MenuModal from '@/components/menu/MenuModal.vue'
import Notifications from '@/components/nav/Notifications.vue'
import Settings from '@/components/nav/Settings.vue'
import { EventBus } from '@/event-bus.js'
import { mapState } from 'vuex'

export default {
  components: {
    Breadcrumb,
    MenuModal,
    Notifications,
    Settings
  },
  data() {
    return {
      pagePath: this.$router.currentRoute.path,
      showBreadcrumb: false,
      modalModuleName: "",
      modalModulePages: []
    }
  },
  computed: {
    ...mapState({
      userObject: "userObject"
    })
  },
  mounted() {
    // Route Updates
    this.$router.afterEach(() => {
      this.pagePath = this.$router.currentRoute.path;
      this.breadcrumbCheck();
      EventBus.$emit('hide-menu-modal');
    });
    // Menu Modal
  },
  methods: {
    breadcrumbCheck: function() {
      if(this.pagePath != "/") {
        this.showBreadcrumb = true;
      }
      else {
        this.showBreadcrumb = false;
      }
    },
    appClick: function() {
      EventBus.$emit('app-click');
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/sass/main.scss";
</style>
